<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Making Teca', route: '/backoffice/making-teca/' }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">Making teca</h1>
</section>

<section class="px-container pb-16">
    <div class="ac-section-head">
        <div>
            <h2>Elenco post</h2>
        </div>
        <a class="acc-btn acc-btn-primary" routerLink="/backoffice/making-teca/add">
            <i class="bi bi-plus"></i>
            Aggiungi post
        </a>
    </div>

    <p-table #dt
        [loading]="loading"
        [value]="making_teca_posts"
        responsiveLayout="stack"
        [breakpoint]="'960px'"
        styleClass="scheda-tabella p-datatable-sm"
        [paginator]="true"
        [showCurrentPageReport]="true"
        [rowHover]="true"
        [globalFilterFields]="['titolo']"
        currentPageReportTemplate="{first} di {last} su {totalRecords} post"
        [rows]="5"
        [rowsPerPageOptions]="[5, 10, 20, 50, 100]">
        <ng-template pTemplate="caption">
            <div class="flex lg:flex-row flex-col gap-3 w-full">
                <div class="w-full">
                    <p-iconfield iconPosition="left" [style]="{'width': '100%'}">
                        <p-inputicon styleClass="bi bi-search" />
                        <input type="text" pInputText (input)="onGlobalFilter(dt, $event)" placeholder="Cerca post…" [style]="{'width': '100%'}" />
                    </p-iconfield>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="data" class="w-3/4">Data <span class="inline-flex"><p-sortIcon field="data" /></span></th>
                <th class="w-1/4 text-center">Azioni</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-post>
            <tr>
                <td>
                    <span class="p-column-title">Data</span>
                    <span class="cell-nome">{{post.data | date: 'dd/MM/yyyy'}}</span>
                </td>
                <td class="text-center">
                    <span class="p-column-title">Azioni</span>
                    <div class="table-actions">
                        <i class="bi bi-pencil" [routerLink]="'/backoffice/making-teca/' + post.id"></i>
                        <p-divider layout="vertical"></p-divider>
                        <p-confirmPopup #deletePost>
                            <ng-template pTemplate="headless" let-message>
                                <div class="border-round p-3">
                                    <span class="text-base">{{ message.message }}</span>
                                    <div class="flex align-items-center gap-2 mt-3">
                                        <button type="button" class="acc-btn flex-1" (click)="onDeletePost()">Elimina</button>
                                        <button type="button" class="acc-btn acc-btn-ghost flex-1" (click)="onAnnullaDeletePost()">Annulla</button>
                                    </div>
                                </div>
                            </ng-template>
                        </p-confirmPopup>
                        <i class="bi bi-trash" (click)="onOpenDeletePost($event, post)"></i>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="2">Nessun post trovato.</td>
            </tr>
        </ng-template>
    </p-table>
</section>
